import { useEffect } from "react";

import { useBeforeunload } from "@/shared/hooks/use-before-unload";
import {
  AssessmentLogEventsEnum,
  AssessmentLogsHttpService,
} from "@/shared/services/assessments/assessment-logs-http.service";

export function useTrackCandidateEventsHook(inviteId?: number, testId?: number) {
  // open
  useEffect(() => {
    if (!inviteId || !testId) {
      return;
    }

    (async () => {
      await AssessmentLogsHttpService.saveInviteLogs(inviteId, testId, AssessmentLogEventsEnum.ASSESSMENT_OPENED);
    })();
  }, [inviteId, testId]);

  // close
  useBeforeunload(async () => {
    if (!inviteId || !testId) {
      return;
    }

    await AssessmentLogsHttpService.saveInviteLogs(inviteId, testId, AssessmentLogEventsEnum.ASSESSMENT_CLOSED);
  });
}
